// Presentation conversions. The engine continues to receive its existing fiscal bases.
export function hasAssetInitialBases(config) {
  return Object.keys(config?.taxation?.initialBasisByAsset || {}).length > 0;
}

export function initialAssetBasis(config, row, capital, gainFraction) {
  const saved = config?.taxation?.initialBasisByAsset?.[row.assetId];
  if (saved != null) return saved * capital / (config.taxation.basisReferenceCapital || capital);
  return capital * row.weight * (1 - gainFraction);
}

export function brokerGainFromBasis(value, basis) {
  return basis === 0 && value > 0 ? Infinity : (value / basis - 1) * 100;
}

export function basisFromBrokerGain(value, gainPct) {
  if (!Number.isFinite(gainPct) || gainPct <= -100) return NaN;
  return value / (1 + gainPct / 100);
}

export function portfolioGainFromBases(config, capital, fallbackFraction) {
  const rows = (config?.allocations || []).filter(a => a.assetId && a.weight > 0);
  const value = rows.reduce((s, a) => s + capital * a.weight, 0);
  const basis = rows.reduce((s, a) => s + initialAssetBasis(config, a, capital, fallbackFraction), 0);
  return value > 0 ? (1 - basis / value) * 100 : fallbackFraction * 100;
}
